import {AddSingleFormatToCartModel} from "../../../shared/models/cart/add-single-format-to-cart.model";

export class QuickShopFormModel {
    public formats: Array<AddSingleFormatToCartModel> = new Array<AddSingleFormatToCartModel>();
}
